import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["next"]
  static values = { url: String, questionKeys: Array }

  connect() {
    this.refreshNextButton()
  }

  save(event) {
    const input = event.target
    const formData = new FormData()
    formData.append("question_key", input.name)
    formData.append("answer", input.value)

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      },
      body: formData
    }).then((response) => {
      if (!response.ok) input.checked = false
      this.refreshNextButton()
    })
  }

  refreshNextButton() {
    if (!this.hasNextTarget) return

    this.nextTarget.disabled = !this.questionKeysValue.every((key) => {
      return this.element.querySelector(`input[name="${key}"]:checked`)
    })
  }
}
